import { ref, computed } from "vue";
import { defineStore } from "pinia";

// Dedicated-org deployments set this at build time; shared deployments leave
// it empty and the router guard resolves the slug from the URL instead.
const envOrgSlug = (import.meta.env.VITE_ORG_SLUG as string | undefined) || "";

export const useOrgStore = defineStore("org", () => {
  const routeOrgSlug = ref("");

  const isDedicated = computed(() => !!envOrgSlug);
  const orgSlug = computed(() => envOrgSlug || routeOrgSlug.value);

  const setRouteOrgSlug = (slug: string) => {
    routeOrgSlug.value = slug;
  };

  return { orgSlug, isDedicated, setRouteOrgSlug };
});
